export default "__VITE_ASSET__CdaI08DC__"